import StartContainer from './start_container'

export default StartContainer